const branches = {
  branches: {
    pageHeader: 'Oddziały',
    addBranchOffice: '+ Dodaj oddział',
    name: 'Imię i nazwisko',
    city: 'Miejscowość',
    state: 'Województwo/powiat',
    country: 'Kraj',
    branches: 'Oddziały',
    noBranchAvailable: '** Brak dostępnych oddziałów **'
  }
};

export default branches;
